(function () {
	'use strict';

    angular.module("imApp").factory("pohTopService", ['$ihttp', function ($ihttp) {
		let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1350,
                    parameters: parms || {}
                });
            },
            listSubPos: function (parms) {
                return $ihttp.post({
                    method: 1351,
                    parameters: parms || {}
                });
            }
		};

		return service;
	}]);
})();
